/**
 * Shared Unit baseline list ordering (Slice 20a list = 20b check order).
 */
import type { PropertyUnitItem } from "@/hooks/useUnitItems";

export const UNIT_ROOM_SORT_ORDER = ["Living", "Kitchen", "Bedroom", "Bath"] as const;

export function isPresetUnitRoom(room: string): boolean {
  return (UNIT_ROOM_SORT_ORDER as readonly string[]).includes(room);
}

export function sortUnitItems(items: PropertyUnitItem[]): PropertyUnitItem[] {
  const rank = (room: string | null) => {
    if (!room) return 998;
    const i = UNIT_ROOM_SORT_ORDER.indexOf(room as (typeof UNIT_ROOM_SORT_ORDER)[number]);
    if (i >= 0) return i;
    return 900;
  };
  return [...items].sort((a, b) => {
    const ra = rank(a.room);
    const rb = rank(b.room);
    if (ra !== rb) return ra - rb;
    const nameA = (a.room || "").localeCompare(b.room || "");
    if (nameA !== 0) return nameA;
    if (a.sort_order !== b.sort_order) return a.sort_order - b.sort_order;
    return a.name.localeCompare(b.name);
  });
}
